import { com } from '@eidu/form'
import formsBaseUrl from './baseUrl'
import bearerTokenHeader from '../authorization/bearerTokenHeader'
import formContentIdFromString = com.eidu.sharedlib.entity.kind.form.formContentIdFromString
import FormContentIdAndHash from '../../../domain/form/FormContentIdAndHash'
import FormContent = com.eidu.sharedlib.form.FormContent
import encodeCreateFormContentRequestToJson = com.eidu.sharedlib.form.encodeCreateFormContentRequestToJson
import CreateFormContentRequest = com.eidu.sharedlib.form.CreateFormContentRequest
import requireAuthContext from '../authorization/requireAuthContext'

type PostFormContentParameters = {
  formId: String
  content: FormContent
}

const postFormContent = async ({ formId, content }: PostFormContentParameters): Promise<FormContentIdAndHash> => {
  const authContext = await requireAuthContext()
  const requestBody = new CreateFormContentRequest(content)
  const response = await fetch(`${formsBaseUrl}/organizations/${authContext.organizationId}/forms/${formId}/contents`, {
    method: 'POST',
    headers: {
      ...bearerTokenHeader(authContext.accessToken),
      'Content-Type': 'application/json',
    },
    body: encodeCreateFormContentRequestToJson(requestBody),
  })
  const responseJson = await response.json()
  if (response.status !== 200 && responseJson) throw Error(responseJson.message)

  return { contentId: formContentIdFromString(responseJson.contentId), contentSha256: responseJson.contentSha256 }
}

export default postFormContent
